import { createFileRoute } from '@tanstack/react-router';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { NotebookDashboard } from '@/features/notebook/NotebookDashboard';

export const Route = createFileRoute('/_authenticated/notebook')({
  component: NotebookPage,
});

function NotebookPage() {
  return (
    <PermissionGate permission={Permission.NOTEBOOK_VIEW}>
      <NotebookDashboard />
    </PermissionGate>
  );
}
